<template>
    <div class="zebra-crossing-detail">
        <!--  表单明细 -->
        <el-form :model="detail" label-width="140px">
                <el-row>
                    <el-col>
                        <el-form-item label="标题:">{{ detail.title}}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="资产类型:">{{ detail.assetType | tableVal(cmdbAssetType)}}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="资产成本:">{{ detail.assetCost }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="环境类型:">{{ detail.envType | tableVal(envType) }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="型号:">{{ detail.model }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="序列号:">{{ detail.serialNum }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="品牌:">{{ detail.brand | tableVal(brand)}}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="供应商:">{{ detail.supplier | tableVal(supplier)}}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="所在位置:">{{ detail.place | tableVal(location) }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="物理地址:">{{ detail.physicalAddress }}</el-form-item>
                    </el-col>

                    <el-col>
                        <el-form-item label="采购时间:">{{ detail.purchaseTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="到货时间:">{{ detail.arrivalTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="借用到期日:">{{ detail.borrowEndTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="保修开始时间:">{{ detail.warrantyStartTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="保修结束时间:">{{ detail.warrantyEndTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="报废日期:">{{ detail.retireTime }}</el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="描述:">
                            {{detail.description}}
                        </el-form-item>
                    </el-col>
                </el-row>
        </el-form>
    </div>
</template>

<script>
import { cmdbDetailSimple } from './configuration/configuration.services.js'
export default {
    data() {
        return {
            detail: {},
            loading: true,
        }
    },
    mounted() {
        cmdbDetailSimple({serialNumber:this.serialNumber})
            .then(res => this.detail = res)
            .catch(err => this.$message.error(err.message))
            .finally(() => this.loading = false)
    },
    computed:{
        serialNumber() {
            return this.$route.query.serialNumber
        },
        dictionary(){
            return this.$store.state.dictionary;
        },
        //资产类型
        cmdbAssetType(){
            return this.dictionary.cmdb_asset_type;
        },
        //环境类型
        envType(){
            return this.dictionary.env_type;
        },
        // 品牌
        brand(){
            return this.dictionary.brand;
        },
        // 供应商
        supplier(){
            return this.dictionary.supplier;
        },
        // 所在位置
        location(){
            return this.dictionary.location;
        },

        // 影响范围
        influence(){
            return this.dictionary.influence;
        }
    },

}
</script>

<style>

</style>
